import React, { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { useLocation } from 'react-router-dom';
import WorkshopNavbar from "../../../frontend/WorkShop/WorkshopNavbar/WorkshopNavbar";
import NewVersionAbstractFooter from "../../AbstractAuth/NewVersion/NewVersionAnstractFooter";

import { Link } from 'react-router-dom';
import { Button, Box, Grid } from '@mui/material';


const PaymentReturnUrl = () => {
  const [paymentRes, setPaymentRes] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const eventid = localStorage.getItem('eventid');


  const location = useLocation();
  const pathname = location.pathname;
  const segments = pathname.split('/'); // Split the pathname by '/'

  const encrypt_eventId = segments[segments.length - 1]; // Get the second-to-last segment
  const encrypt_participantId = segments[segments.length - 2]; // Get the last segment


  useEffect(() => {
    const fetchPaymentResponse = async () => {
      try {
        // Make POST request to fetch payment response from backend
        const response = await axios.post(`/api/paytabs/payments/callback`, {
          encrypt_participantId: encrypt_participantId,
          encrypt_eventId: encrypt_eventId
        });

        if (response.data) {
          // Handle successful response
          console.log('Payment response:', response.data);

          setPaymentRes(response.data)
        } else {
          setError("Empty response or invalid data");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentResponse();
  }, [encrypt_participantId, encrypt_eventId]);

  // if(paymentRes?.email == 0){
  //   alert('email send function');
  // }

  const id = paymentRes?.p_id;
  //const emailSent = sessionStorage.getItem('emailSent');
  //&& !emailSent
  if (paymentRes?.email === 1) {
    // alert('Sending email...');

    // Fetch CSRF cookie for secure API requests
    axios.get('/sanctum/csrf-cookie').then(() => {
      const data = {
        eventid,
      };

      axios.post(`/api/workshop-particepant-online-verification-email-send/${id}`, data).then(res => {
        if (res.data.status === 200) {
          swal('Success', 'Please check your email. Your QR code has been sent to your registered email. Thank you!', 'success');


        } else {
          swal('Error', 'There was an issue sending the email. Please try again later.', 'error');
        }
      }).catch(error => {
        console.error('Error during email send:', error);
        swal('Error', 'An error occurred while sending the email.', 'error');
      });

    }).catch(error => {
      console.error('Error fetching CSRF cookie:', error);
      swal('Error', 'Could not authenticate the request. Please try again later.', 'error');
    });

    // Set flag in sessionStorage to prevent sending the email again during the session
    //sessionStorage.setItem('emailSent', 'true');
  } else if (paymentRes?.email === 0) {
    // cancel case
    axios.get('/sanctum/csrf-cookie').then(() => {
      const data = { eventid };

      axios.post(`/api/workshop-participant-online-cancellation-email-send/${id}`, data)
        .then(res => {
          if (res.data.status === 200) {
            swal(
              'Cancelled',
              'Your online payment was cancelled. A cancellation email has been sent to your registered email.',
              'success'
            );
          } else {
            swal(
              'Error',
              'There was an issue sending the cancellation email. Please try again later.',
              'error'
            );
          }
        })
        .catch(error => {
          console.error('Error during cancellation email send:', error);
          swal(
            'Error',
            'An error occurred while sending the cancellation email.',
            'error'
          );
        });
    }).catch(error => {
      console.error('Error fetching CSRF cookie:', error);
      swal(
        'Error',
        'Could not authenticate the request. Please try again later.',
        'error'
      );
    });
  }

  // else if(paymentRes?.email === 0){
  //   swal('Success', 'You Cancel Your online payment. Thank you!', 'success');
  // }


  if (loading) {
    return <h1>Loading...</h1>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (

    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Grid item xs={12} sm={10} md={8} lg={6}>
        <WorkshopNavbar />
      </Grid>
      <Box sx={{ m: 2, color: '#000000' }}>
        <Button
          sx={{
            float: 'right',
            marginTop: '2%',
            ":hover": {
              color: "white"
            }
          }}
          color='success'
          size='small'
          variant='contained'
          component={Link}  // Use the Link component here
          to="/workshop/particpant-verification"
        >
          Back To Verification
        </Button>

      </Box>
      <Box
        sx={{
          textAlign: "center",
          color: "#000000",
          mt: "2%",
          flexGrow: 1,
        }}
      >
        {paymentRes?.email === 1 ? (
          <>
            <h2 style={{ color: "#2e7d32" }}>✅ Online Payment Successful</h2>
            <h4>QrCode ID: {paymentRes?.p_id}</h4>
            <h4>
              Thank you for participating! Please check your email for your QR code
              and event details.
            </h4>
          </>
        ) : paymentRes?.email === 0 ? (
          <>
            <h2 style={{ color: "#d32f2f" }}>❌ Online Payment Cancelled</h2>
            <h4>QrCode ID: {paymentRes?.p_id}</h4>
            <h4>
              Your registration is still saved. Please check your email for more
              details regarding the cancellation.
            </h4>
          </>
        ) : (
          <>
            <h2>ℹ️ Online Payment Status</h2>
            <h4>We are processing your payment status, please wait...</h4>
          </>
        )}
      </Box>

      {/* <Box sx={{ textAlign: 'center', color: '#000000', mt: '2%', flexGrow: 1 }}>
     
        <h2>Online Payment</h2>
        <h4>QrCode ID: {paymentRes?.p_id}</h4>
    
        <h4>Thank you for participating!</h4>
      </Box> */}
      <Grid item xs={12} sm={10} md={8} lg={6} sx={{ mt: 'auto' }}>
        <NewVersionAbstractFooter />
      </Grid>
    </div>
  );
};

export default PaymentReturnUrl;
